import { createStore } from 'effector'
import { getTariffsFx, setHandlerTariffFx, setPeriodFx } from './event'
import { GetTariffsRes, Period } from '../../services/api/Tafiff'
import { arrayWithObjectToCamelCase } from '@finanso/react-uikit'

export const $tariffs = createStore<GetTariffsRes>([])
  .on(getTariffsFx.done, (_, { result }) => arrayWithObjectToCamelCase(result.value.data))

export const $tariffsLoading = createStore(true)
  .on(getTariffsFx.pending, (_, pending) => pending)

export type HandlerTariff = (id: number) => void
export const $handlerTariff = createStore<HandlerTariff>(() => null)
  .on(setHandlerTariffFx, (_, handler) => handler)

export const $period = createStore<Period>(Period.MONTH)
  .on(setPeriodFx, (_, period) => period)
